import { render, staticRenderFns } from "./priceDifference.vue?vue&type=template&id=682a746b&scoped=true&"
import script from "./priceDifference.vue?vue&type=script&lang=js&"
export * from "./priceDifference.vue?vue&type=script&lang=js&"
import style0 from "./priceDifference.vue?vue&type=style&index=0&id=682a746b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a746b",
  null
  
)

export default component.exports